<template>
  <div class="wrapper">
    <side-bar class="no-scrollbar shadow lg-shadow">
      <sidebar-link class="submenuberanda" to="/admin/home" v-if="['master_admin'].includes(role)">
        <i class="submenuberandai"><img src="/img/home-white.png" style="width:25px; height:25px;"/></i>
        {{dicts.home[dicts.lang]}}
      </sidebar-link>
      <!-- <sidebar-link to="/admin/geoloc/test">
        <i class="nc-icon nc-pin-3"></i>
        <p>Map</p>
      </sidebar-link> -->
      <sidebar-link tag="li" style="cursor: pointer;user-select:none" @click.native="dmLink=!dmLink" v-if="permissions.datamaster.master.includes(role)">
        <i class="submenuberandai"><img src="/img/masterdata-white.png" style="width:25px; height:25px;"/></i>
        {{dicts.masterdata[dicts.lang]}} <div class="float-right icons"><i class="nc-icon nc-stre-down"></i></div>
        <transition name="fade">
          <div class="w-100 my-0 pl-0 border border-light shadow-sm submenu" v-if="dmLink">
            <sidebar-link v-if="permissions.datamaster.submodule.aplikasi.includes(role)" class="nav-link mb-0 mt-0 mx-0 px-0 my-0 py-0 d-block" to="/admin/datamaster/application"><i class="submenui" ></i><img src="/img/masterdata-white.png" style="width:25px; height:25px; margin-right:12px; margin-left:12px"/> <span>{{dicts.application[dicts.lang]}}</span></sidebar-link>
            <!-- <sidebar-link class="nav-link mb-0 mt-1 mx-0 px-1 py-0 d-block" to="/admin/datamaster/vessel" v-if="permissions.datamaster.submodule.vessel.includes(role)"><i class="nc-icon nc-square-pin submenui"></i> <span>{{dicts.vessel[dicts.lang]}}</span></sidebar-link>
            <sidebar-link v-if="permissions.datamaster.submodule.listvessel.includes(role)" class="nav-link mb-0 mt-1 mx-0 px-1 py-0 d-block" to="/admin/datamaster/list-kapal"><i class="nc-icon nc-bullet-list-67 submenui"></i> <span>{{dicts.listvessel[dicts.lang]}}</span></sidebar-link> -->
            <sidebar-link v-if="permissions.datamaster.submodule.user.includes(role)" class="nav-link mb-0 mt-0 mx-0 px-0 my-0 py-0 d-block" to="/admin/datamaster/pengguna"><i class="submenui" ></i><img src="/img/masterdata-white.png" style="width:25px; height:25px; margin-right:12px; margin-left:12px"/> <span>{{dicts.user[dicts.lang]}}</span></sidebar-link>
            <!-- <sidebar-link v-if="permissions.datamaster.submodule.client.includes(role)" class="nav-link mb-0 mt-1 mx-0 px-1 my-0 py-0 d-block" to="/admin/datamaster/klien"><i class="nc-icon nc-circle-09 submenui" ></i> <span>{{dicts.client[dicts.lang]}}</span></sidebar-link> -->
            <!-- <sidebar-link v-if="permissions.datamaster.submodule.rekeningbank.includes(role)" class="nav-link mb-0 mt-1 mx-0 px-1 my-0 py-0 d-block" to="/admin/datamaster/rekening-bank"><i class="nc-icon nc-notes submenui" ></i> <span>{{dicts.banks[dicts.lang]}}</span></sidebar-link> -->
            <sidebar-link v-if="permissions.datamaster.submodule.nocs.includes(role)" class="nav-link mb-0 mt-0 mx-0 px-0 my-0 py-0 d-block" to="/admin/datamaster/noc"><i class="submenui" ></i><img src="/img/masterdata-white.png" style="width:25px; height:25px; margin-right:12px; margin-left:12px"/> <span>{{dicts.noc[dicts.lang]}}</span></sidebar-link>
            <sidebar-link v-if="permissions.datamaster.submodule.tipeperangkat.includes(role)" class="nav-link mb-0 mt-0 mx-0 px-0 my-0 py-0 d-block" to="/admin/datamaster/hardwaretype"><i class="submenui" ></i><img src="/img/masterdata-white.png" style="width:25px; height:25px; margin-right:12px; margin-left:12px"/> <span>{{dicts.itemtype[dicts.lang]}}</span></sidebar-link>
            <sidebar-link v-if="permissions.datamaster.submodule.perangkat.includes(role)" class="nav-link mb-0 mt-0 mx-0 px-0 my-0 py-0 d-block" to="/admin/datamaster/hardware"><i class="submenui" ></i><img src="/img/masterdata-white.png" style="width:25px; height:25px; margin-right:12px; margin-left:12px"/> <span>{{dicts.item[dicts.lang]}}</span></sidebar-link>
            <sidebar-link v-if="permissions.datamaster.submodule.hargaitem.includes(role)" class="nav-link mb-0 mt-0 mx-0 px-0 my-0 py-0 d-block" to="/admin/datamaster/item-lain"><i class="submenui"></i><img src="/img/masterdata-white.png" style="width:25px; height:25px; margin-right:12px; margin-left:12px"/> <span>{{dicts.hargaitem[dicts.lang]}}</span></sidebar-link>
            <sidebar-link v-if="permissions.datamaster.submodule.datavendor.includes(role)" class="nav-link mb-0 mt-0 mx-0 px-0 my-0 py-0 d-block" to="/admin/datamaster/vendor"><i class="submenui" ></i><img src="/img/masterdata-white.png" style="width:25px; height:25px; margin-right:12px; margin-left:12px"/> <span>{{dicts.vendor[dicts.lang]}}</span></sidebar-link>
            <!-- <sidebar-link v-if="permissions.datamaster.submodule.hargaperangkat.includes(role)" class="nav-link mb-0 mt-1 mx-0 px-1 my-0 py-0 d-block" to="/admin/datamaster/hardware-price"><i class="nc-icon nc-money-coins submenui"></i> <span>{{dicts.itemprice[dicts.lang]}}</span></sidebar-link>
            <sidebar-link v-if="permissions.datamaster.submodule.hargaairtime.includes(role)" class="nav-link mb-0 mt-1 mx-0 px-1 my-0 py-0 d-block" to="/admin/datamaster/airtime-price"><i class="nc-icon nc-money-coins submenui"></i> <span>{{dicts.airtimeprice[dicts.lang]}}</span></sidebar-link>
            <sidebar-link v-if="permissions.datamaster.submodule.discount.includes(role)" class="nav-link mb-0 mt-1 mx-0 px-1 my-0 py-0 d-block" to="/admin/datamaster/discount"><i class="nc-icon nc-tag-content submenui"></i> <span>{{dicts.discount[dicts.lang]}}</span></sidebar-link> -->
            <!-- <sidebar-link v-if="permissions.datamaster.submodule.paket.includes(role)" class="nav-link mb-0 mt-1 mx-0 px-1 my-0 py-0 d-block" to="/admin/datamaster/packet"><i class="nc-icon nc-single-copy-04 submenui"></i> <span>{{dicts.packet[dicts.lang]}}</span></sidebar-link>
            <sidebar-link v-if="permissions.datamaster.submodule.tipekwitansi.includes(role)" class="nav-link mb-0 mt-1 mx-0 px-1 my-0 py-0 d-block" to="/admin/datamaster/kwitansi-type"><i class="nc-icon nc-single-copy-04 submenui"></i> <span>{{dicts.kwitansitype[dicts.lang]}}</span></sidebar-link>
            <sidebar-link v-if="permissions.datamaster.submodule.location.includes(role)" class="nav-link mb-0 mt-1 mx-0 px-1 my-0 py-0 d-block" to="/admin/datamaster/location"><i class="nc-icon nc-map-big submenui"></i> <span>{{dicts.location[dicts.lang]}}</span></sidebar-link>
            <sidebar-link v-if="permissions.datamaster.submodule.warehouse.includes(role)" class="nav-link mb-0 mt-1 mx-0 px-1 my-0 py-0 d-block" to="/admin/datamaster/warehouse"><i class="nc-icon nc-map-big submenui"></i> <span>{{dicts.warehouse[dicts.lang]}}</span></sidebar-link>
            <sidebar-link v-if="permissions.datamaster.submodule.complaint.includes(role)" class="nav-link mb-0 mt-1 mx-0 px-1 my-0 py-0 d-block" to="/admin/datamaster/complaint"><i class="nc-icon nc-settings-90 submenui"></i> <span>{{dicts.complaint[dicts.lang]}}</span></sidebar-link> -->
          </div>
        </transition>
            <!-- <i class="nc-icon nc-circle-09"></i> -->
      </sidebar-link >

      <sidebar-link tag="li" style="cursor: pointer;user-select:none" @click.native="dmLinkInventaris=!dmLinkInventaris"  v-if="permissions.inventaris.master.includes(role)">
        <i class="submenuberandai"><img src="/img/inventaris-white.png" style="width:30px; height:30px;"/></i>
        {{dicts.inventory[dicts.lang]}} <div class="float-right icons"><i class="nc-icon nc-stre-down"></i></div>
        <transition name="fade">
          <div class="w-100 my-0 pl-0 border border-light shadow-sm submenu" v-if="dmLinkInventaris">
            <!-- <sidebar-link v-if="permissions.inventaris.submodule.qc.includes(role)" class="nav-link mb-0 mt-1 mx-0 px-1 py-0 d-block" to="/admin/inventaris/hardware-qc"><i class="submenui"><img src="/img/icon-inventaris.svg"/></i> <span>{{dicts.qc[dicts.lang]}}</span></sidebar-link> -->
            <sidebar-link v-if="permissions.inventaris.submodule.setup.includes(role)" class="nav-link mb-0 mt-0 mx-0 px-0 py-0 d-block" to="/admin/inventaris/hardware-setup"><i class="submenui"></i><img src="/img/inventaris-white.png" style="width:30px; height:30px; margin-right:12px; margin-left:12px"/> <span>{{dicts.setup[dicts.lang]}}</span></sidebar-link>
            <!-- <sidebar-link v-if="permissions.inventaris.submodule.warehouse.includes(role)" class="nav-link mb-0 mt-1 mx-0 px-1 py-0 d-block" to="/admin/inventaris/warehouse"><i class="submenui"><img src="/img/icon-inventaris.svg"/></i> <span>{{dicts.warehouse_stock[dicts.lang]}}</span></sidebar-link> -->
          </div>
        </transition>
      </sidebar-link>

      <!-- <sidebar-link tag="li" style="cursor: pointer;user-select:none" @click.native="dmLinkPemesanan=!dmLinkPemesanan"  v-if="permissions.pemesanan.master.includes(role)">
        <i class="submenuberandai"><img src="/img/icon-pemesanan.svg"/></i>
        {{dicts.order[dicts.lang]}} <div class="float-right icons"><i class="nc-icon nc-stre-down"></i></div>
        <transition name="fade">
          <div class="w-100 my-2 pl-1 border border-light shadow-sm submenu" v-if="dmLinkPemesanan">
            <sidebar-link class="nav-link mb-0 mt-1 mx-0 px-1 py-0 d-block" to="/admin/pemesanan/purchase-order" v-if="permissions.pemesanan.submodule.po.includes(role)"><i class="submenui"><img src="/img/icon-pemesanan.svg"/></i> <span>{{dicts.po[dicts.lang]}}</span></sidebar-link>
            <sidebar-link class="nav-link mb-0 mt-1 mx-0 px-1 py-0 d-block" to="/admin/pemesanan/kwitansi" v-if="permissions.pemesanan.submodule.kwitansi.includes(role)"><i class="submenui"><img src="/img/icon-pemesanan.svg"/></i> <span>{{dicts.kwitansi[dicts.lang]}}</span></sidebar-link>
            <sidebar-link class="nav-link mb-0 mt-1 mx-0 px-1 my-0 py-0 d-block" to="/admin/pemesanan/sales-order" v-if="permissions.pemesanan.submodule.so.includes(role)"><i class="submenui"><img src="/img/icon-pemesanan.svg"/></i> <span>{{dicts.so[dicts.lang]}}</span></sidebar-link>
            <sidebar-link class="nav-link mb-0 mt-1 mx-0 px-1 my-0 py-0 d-block" to="/admin/pemesanan/invoice-item" v-if="permissions.pemesanan.submodule.invoiceitem.includes(role)"><i class="submenui"><img src="/img/icon-pemesanan.svg"/></i> <span>{{dicts.invoiceitem[dicts.lang]}}</span></sidebar-link>
            <sidebar-link class="nav-link mb-0 mt-1 mx-0 px-1 my-0 py-0 d-block" to="/admin/pemesanan/invoice-airtime" v-if="permissions.pemesanan.submodule.invoiceairtime.includes(role)"><i class="submenui"><img src="/img/icon-pemesanan.svg"/></i> <span>{{dicts.invoiceairtime[dicts.lang]}}</span></sidebar-link>
            <sidebar-link class="nav-link mb-0 mt-1 mx-0 px-1 my-0 py-0 d-block" to="/admin/pemesanan/invoice-lain" v-if="permissions.pemesanan.submodule.otherinvoice.includes(role)"><i class="submenui"><img src="/img/icon-pemesanan.svg"/></i> <span>{{dicts.otherinvoice[dicts.lang]}}</span></sidebar-link>
          </div>
        </transition>
      </sidebar-link> -->

      <sidebar-link tag="li" style="cursor: pointer;user-select:none" @click.native="dmLinkPemesanan=!dmLinkPemesanan"  v-if="permissions.pemesanan.master.includes(role)">
        <i class="submenuberandai"><img src="/img/invoice-white.png" style="width:22px; height:25px;"/></i>
        {{dicts.order[dicts.lang]}} <div class="float-right icons"><i class="nc-icon nc-stre-down"></i></div>
        <transition name="fade">
          <div class="w-100 my-0 pl-0 border border-light shadow-sm submenu" v-if="dmLinkPemesanan">
            <sidebar-link class="nav-link mb-0 mt-0 mx-0 px-0 py-0 d-block" to="/admin/pemesanan/invoice-lain" v-if="permissions.pemesanan.submodule.otherinvoice.includes(role)"><i class="submenui"></i><img src="/img/invoice-white.png" style="width:22px; height:25px; margin-right:12px; margin-left:12px"/> <span>{{dicts.invoiceairtime[dicts.lang]}}</span></sidebar-link>
          </div>
        </transition>
      </sidebar-link>

      <!-- <sidebar-link tag="li" style="cursor: pointer;user-select:none" @click.native="dmLinkLaporan=!dmLinkLaporan" v-if="permissions.laporan.master.includes(role)">
        <i class="submenuberandai"><img src="/img/icon-laporan.svg"/></i>
        {{dicts.report[dicts.lang]}} <div class="float-right icons"><i class="nc-icon nc-stre-down"></i></div>
        <transition name="fade">
          <div class="w-100 my-2 pl-1 border border-light shadow-sm submenu" v-if="dmLinkLaporan">
            <sidebar-link class="submenuberanda" to="/misc/unit-report" v-if="permissions.laporan.submodule.unit.includes(role)">
            <i class="submenui"><img src="/img/icon-laporan.svg"/></i> 
              {{dicts.unit[dicts.lang]}}
            </sidebar-link>
            <sidebar-link class="submenuberanda" to="/misc/airtime-report" v-if="permissions.laporan.submodule.airtime.includes(role)">
              <i class="submenui"><img src="/img/icon-laporan.svg"/></i>
              Airtime
            </sidebar-link>
            <sidebar-link class="submenuberanda" to="/misc/so-report" v-if="permissions.laporan.submodule.so.includes(role)">
              <i class="submenui"><img src="/img/icon-laporan.svg"/></i>
              SO
            </sidebar-link>
            <sidebar-link class="submenuberanda" to="/misc/other-report" v-if="permissions.laporan.submodule.other.includes(role)">
              <i class="submenui"><img src="/img/icon-laporan.svg"/></i>
              {{dicts.other[dicts.lang]}}
            </sidebar-link>
            <sidebar-link class="submenuberanda" to="/misc/kwitansi-report" v-if="permissions.laporan.submodule.receipt.includes(role)">
              <i class="submenui"><img src="/img/icon-laporan.svg"/></i>
              {{dicts.receipt[dicts.lang]}}
            </sidebar-link>
            <sidebar-link class="submenuberanda" to="/misc/troubleshootreport" v-if="permissions.laporan.submodule.troubleshootreport.includes(role)">
              <i class="submenui"><img src="/img/icon-laporan.svg"/></i>
              {{dicts.troubleshootreport[dicts.lang]}}
            </sidebar-link>
            <sidebar-link class="submenuberanda" to="/misc/reminderletter" v-if="permissions.laporan.submodule.reminderletter.includes(role)">
              <i class="submenui"><img src="/img/icon-laporan.svg"/></i>
              {{dicts.reminderletter[dicts.lang]}}
            </sidebar-link>
            
          </div>
        </transition>
      </sidebar-link> -->

      <!-- <sidebar-link tag="li" style="cursor: pointer;user-select:none" @click.native="dmLinkPengingat=!dmLinkPengingat" v-if="permissions.pengingat.master.includes(role)">
        <i class="submenuberandai"><img src="/img/icon-pengingat.svg"/></i>
        {{dicts.reminder[dicts.lang]}} <div class="float-right icons"><i class="nc-icon nc-stre-down"></i></div>
        <transition name="fade">
          <div class="w-100 my-2 pl-1 border border-light shadow-sm submenu" v-if="dmLinkPengingat">
            <sidebar-link class="nav-link mb-0 mt-1 mx-0 px-1 py-0 d-block" to="/admin/pengingat/renewal-airtime" v-if="permissions.pengingat.submodule.renewalairtime.includes(role)">
            <i class="submenui"><img src="/img/icon-pengingat.svg"/></i>
              <span>{{dicts.renewalairtime[dicts.lang]}}</span>
            </sidebar-link>
          </div>
        </transition>
      </sidebar-link> -->

      <sidebar-link tag="li" style="cursor: pointer;user-select:none" @click.native="dmLinkMonitoring=!dmLinkMonitoring" v-if="permissions.troubleshoot.master.includes(role)">
        <i class="submenuberandai"><img src="/img/support-white.png" style="width:25px; height:25px;"/></i>
        {{dicts.troubleshoot[dicts.lang]}} <div class="float-right icons"><i class="nc-icon nc-stre-down"></i></div>
        <transition name="fade">
          <div class="w-100 my-0 pl-0 border border-light shadow-sm submenu" v-if="dmLinkMonitoring">
             <sidebar-link class="submenuberanda" to="/misc/troubleshoot" v-if="permissions.troubleshoot.submodule.monitoring.includes(role)">
              <i class="submenui"></i><img src="/img/support-white.png" style="width:25px; height:25px; margin-right:12px; margin-left:12px"/>
              {{dicts.monitoring[dicts.lang]}}
            </sidebar-link>
          </div>
        </transition>
      </sidebar-link>

      

      <!-- <sidebar-link to="/admin/table-list">
        <i class="nc-icon nc-notes"></i>
        <p>Table list</p>
      </sidebar-link>
      <sidebar-link to="/admin/typography">
        <i class="nc-icon nc-paper-2"></i>
        <p>Typography</p>
      </sidebar-link>
      <sidebar-link to="/admin/icons">
        <i class="nc-icon nc-atom"></i>
        <p>Icons</p>
      </sidebar-link>
      <sidebar-link to="/admin/maps">
        <i class="nc-icon nc-pin-3"></i>
        <p>Maps</p>
      </sidebar-link>
      <sidebar-link to="/admin/notifications">
        <i class="nc-icon nc-bell-55"></i>
        <p>Notifications</p>
      </sidebar-link> -->

      <!-- <template slot="bottom-links">
        <sidebar-link class="active"
                      to="/admin/upgrade">
          <i class="nc-icon nc-alien-33"></i>
          <p>Upgrade to PRO</p>
        </sidebar-link>
      </template> -->
      <template slot="bottom-links">
        <mobile-menu slot="content"></mobile-menu>
      </template>
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>

      <dashboard-content @click="toggleSidebar">

      </dashboard-content>

      <!-- <content-footer></content-footer> -->
    </div>
  </div>
</template>

<style lang="scss">
  

</style>

<style scoped>
::v-deep .sidebar .sidebar-wrapper, body > .navbar-collapse .sidebar-wrapper {
    background: #170BCA;
}
.sidebar .nav li .nav-link .icons i {
    font-size: 15px;
    margin-right: 15px;
    padding-top: 5px;
}
::v-deep .sidebar .logo, body > .navbar-collapse .logo {
    background: #F2F6FC;
    box-shadow: 0px 1px 3px #dfdfdf;
    border: 0.1px solid #dfdfdf;
}

 ::v-deep .sidebar .nav li .nav-link, body > .navbar-collapse .nav li {
    /* color: #fff !important; */
}

::v-deep .sidebar .nav li.active .nav-link, body > .navbar-collapse .nav li.active {
    background: #1096fb;
}
::v-deep .sidebar .nav li:hover .nav-link, body > .navbar-collapse .nav li:hover  {
    background: #1096fb;
    /* color: #fff !important; */
    
    opacity: 1;
    font-weight: bold;
}

::v-deep .sidebar .nav li:visited .nav-link, body > .navbar-collapse .nav li:visited  {
    background: rgba(255, 255, 255, 1);
    opacity: 1;
    color: #002060;
}
::v-deep .border {
  border: 0px solid #dee2e6 !important;
}
::v-deep .submenu {
  background: rgba(255, 255, 255, 1);
  color: #fff !important;
  opacity: 1;
  border-radius: 5px;
}
.submenu .submenui, span {
  color: #fff;
}
.submenuberanda .submenuberandai.active {
  color: #fff;
}

.sidebar .nav li .nav-link, body > .navbar-collapse .nav li .nav-link {
    /* color: #fff !important; */
    opacity: 1;
    border:0;
}

::v-deep .sidebar .nav li .nav-link i, body > .navbar-collapse .nav li .nav-link i {
    font-size: 22px;
    margin-right: 5px;
}
::v-deep .sidebar .nav .nav-link, body > .navbar-collapse .nav .nav-link {
    margin: 0;
    font-size: 11px;
}

.sidebar .nav li {
  background-color: #1096fb;
}

::v-deep .sidebar .nav, body > .navbar-collapse .nav {
  background-color: #1096fb;
  margin-top:0;
}

::v-deep .sidebar .nav li .nav-link, body > .navbar-collapse .nav li .nav-link {
  color: #fff !important;
}

</style>
<style>
body{
  font-size: 14px;
}
.navbar {
    font-size: 14px;
    padding: 0 15px;
}
</style>
<script>
  import {EventBus} from './../eventbus'
  import TopNavbar from './TopNavbar.vue'
  import ContentFooter from './ContentFooter.vue'
  import DashboardContent from './Content.vue'
  import MobileMenu from './MobileMenu.vue'
  export default {
    components: {
      TopNavbar,
      ContentFooter,
      DashboardContent,
      MobileMenu
    },
    data(){
      return {
        passVisible:false,
        role:'',
        dmLink:false,
        dmLinkInventaris:false,
        dmLinkPemesanan:false,
        dmLinkPengingat:false,
        dmLinkLaporan:false,
        dmLinkMonitoring:false,
        dmLinkTroubleshoot:false,
        permissions:{
            datamaster:{
              master:['admin','client','master_admin','finance','supervisor'],
              submodule:{
                vessel:['admin','master_admin','petugas'],
                listvessel:['admin','master_admin','supervisor'],
                user:['client','master_admin'],
                client:['admin','master_admin','supervisor'],
                rekeningbank:['admin','master_admin','supervisor'],
                datavendor:['admin','master_admin','supervisor'],
                tipeperangkat:['admin','master_admin','supervisor'],
                perangkat:['admin','master_admin','supervisor'],
                hargaperangkat:['admin','master_admin','supervisor'],
                hargaairtime:['admin','master_admin','supervisor'],
                hargaitem:['admin','master_admin','supervisor'],
                discount:['admin','master_admin','supervisor'],
                aplikasi:['admin','master_admin','finance','supervisor'],
                nocs:['admin','master_admin','supervisor'],
                paket:['admin','master_admin','supervisor'],
                tipekwitansi:['admin','master_admin','supervisor'],
                location:['admin','master_admin','supervisor'],
                warehouse:['admin','master_admin','supervisor'],
                complaint:['admin','master_admin','supervisor'],
              }
            },
            inventaris:{
              master:['admin','master_admin','finance','supervisor'],
              submodule:{
                qc:['admin','master_admin','supervisor'],
                setup:['admin','master_admin','finance','supervisor'],
                warehouse:['admin','master_admin','supervisor'],
              }
            },
            pemesanan:{
              master:['admin','master_admin','finance','tax'],
              submodule:{
                po:['admin','master_admin','finance','tax'],
                kwitansi:['admin','master_admin','finance','tax'],
                so:['admin','master_admin','finance','tax'],
                invoiceitem:['admin','master_admin','finance','tax'],
                invoiceairtime:['admin','master_admin','finance','tax'],
                otherinvoice:['admin','master_admin','finance','tax'],
              }
            },
            pengingat:{
              master:['admin','master_admin'],
              submodule:{
                renewalairtime:['admin','master_admin']
              }
            },
            laporan:{
              master:['admin','master_admin'],
              submodule:{
                unit:['admin','master_admin'],
                airtime:['admin','master_admin'],
                so:['admin','master_admin'],
                other:['admin','master_admin'],
                receipt:['admin','master_admin'],
                reminderletter:['admin','master_admin'],
                troubleshootreport:['admin','master_admin']
              }
            },
            troubleshoot:{
              master:['admin','master_admin','petugas','supervisor'],
              submodule:{
                monitoring:['admin','master_admin','petugas','supervisor']
              }
            },
        },
        dicts:{
            lang:'id',
            home:{
                id:"Beranda",
                en:"Home"
            },
            masterdata:{
                id:"Data master",
                en:"Master data"
            },
            vessel:{
                id:"Kapal",
                en:"Vessel"
            },
            listvessel:{
                id:"List kapal",
                en:"List vessel"
            },
            user:{
                id:"Pengguna",
                en:"User"
            },
            client:{
                id:"Pelanggan",
                en:"Client"
            },
            banks:{
                id:"Rekening bank",
                en:"Bank accounts"
            },
            vendor:{
                id:"Vendor",
                en:"Vendor"
            },
            itemtype:{
                id:"ODP",
                en:"ODP"
            },
            item:{
                id:"ODP (SPlitter Number)",
                en:"ODP (SPlitter Number)"
            },
            itemprice:{
                id:"Harga perangkat",
                en:"Item price"
            },
            airtimeprice:{
                id:"Harga airtime",
                en:"Airtime price"
            },
            hargaitem:{
                id:"Harga paket",
                en:"Package Price"
            },
            discount:{
                id:"Diskon",
                en:"Discount"
            },
            application:{
                 id:"Pelanggan",
                 en:"Customer"
            },
            noc:{
                 id:"NOC",
                 en:"NOC"
            },
            packet:{
                id:"Paket",
                en:"Packet"
            },
            kwitansitype:{
                id:"Tipe Kwitansi",
                en:"Kwitansi Type"
            },
            inventory:{
                id:"Inventaris",
                en:"Inventory"
            },
            inventory:{
                id:"Inventaris",
                en:"Inventory"
            },
            qc:{
                id:"Hardware QC",
                en:"Hardware QC"
            },
            setup:{
                id:"Hardware setup",
                en:"Hardware setup"
            },
            warehouse_stock:{
                id:"Warehouse Stock",
                en:"Warehouse Stock"
            },
            invoiceitem:{
                id:"Invoice perangkat",
                en:"Item invoice"
            },
            invoiceairtime:{
                id:"Invoice",
                en:"Invoice"
            },
            otherinvoice:{
                id:"Invoice lain",
                en:"Other invoice"
            },
            order:{
                id:"Pemesanan",
                en:"Order"
            },
            po:{
                id:"PO",
                en:"PO"
            },
            kwitansi:{
                id:"Kwitansi",
                en:"Kwitansi"
            },
            so:{
                id:"SO",
                en:"SO"
            },
            reminder:{
                id:"Pengingat",
                en:"Reminder"
            },
            renewalairtime:{
                id:"Perpanjangan Airtime",
                en:"Renewal Airtime"
            },
            monitoring:{
                id:"Pemantauan",
                en:"Monitoring"
            },
            troubleshoot:{
                id:"Perbaikan",
                en:"Troubleshoot"
            },
            location:{
                id:"Lokasi",
                en:"Location"
            },
            warehouse:{
                id:"Gudang",
                en:"Warehouse"
            },
            complaint:{
                id:"Keluhan",
                en:"Complaint"
            },
            reminderletter:{
                id:"Surat pemberitahuan",
                en:"Reminder letter"
            },
            troubleshootreport:{
                id:"Troubleshoot",
                en:"Perbaikan"
            },
            anotherinvoice:{
                id:"Invoice lain-lain",
                en:"Another invoice"
            },
            report:{
                id:"Laporan",
                en:"Report"
            },
            other:{
                id:"Lain",
                en:"Other"
            },
            receipt:{
                id:"Kwitansi",
                en:"Receipt"
            },
            unit:{
                id:"Satuan",
                en:"Unit"
            }
        }
      }
    },
    created(){
      //step 1 auto logout, taruh ini disetiap action
      this.role=localStorage.getItem('role');
      console.log('kok ga ada',this.role);
      EventBus.$on('lang',()=>{
        this.dicts.lang = localStorage.getItem('lang');
      })
    },
    methods: {
      
      toggleSidebar () {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false)
        }
      },
    },
    
  }

</script>
